import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Auth0Lock from 'auth0-lock'
import { withRouter } from 'react-router-dom'
import { translate } from 'react-i18next'
import { graphql, compose } from 'react-apollo'
import i18n, { getDefaultLanguage } from '../../i18n'; 

import { showLogin, showSignup } from '../../libs/authService'
import MainMenuLoggedIn from './MainMenuLoggedIn'
import { Link } from 'react-router-dom'
import { SelectInput } from '../UI'
import Loader from '../UI/Loader'
import get from 'lodash/get'
import { getLanguageOptions } from '../../libs/utils'


class Navbar extends Component {
  static propTypes = {
    clientId: PropTypes.string,
    domain: PropTypes.string,
    chatOnTop: PropTypes.bool,
    user: PropTypes.object,
    history: PropTypes.object,
    setChatOnTop: PropTypes.func
  }

  constructor(props) {
    super(props)

    this.state = {
      navbarCollapsed: true,
      userMenuCollapsed: true,
      guideMenuCollapsed: true,
      activityMenuCollapsed: true,
      profileUser: null
    }

    this._lock = new Auth0Lock(props.clientId, props.domain, {
      auth: {
        params: {
          scope: 'openid email'
        }
      }
    })
  }

  showMainMenu() {
    // if (this.props.history.location.pathname === '/') {
    //   location.href = '/'
    // }
    if (document.body.clientWidth > 767) return

    if (!this.state.userMenuCollapsed) return

    this.setState(
      () => ({
        navbarCollapsed: false
      }),
      () => {
        this.props.updateAppState({
          menuShown: this.state.navbarCollapsed
        })

        document.addEventListener('click', this.hideMenus)
      }
    )
  }

  showGuideMenu() {
    if (!this.state.guideMenuCollapsed) return

    this.setState(
      () => ({
        guideMenuCollapsed: false
      }),
      () => {
        document.addEventListener('click', this.hideMenus)
      }
    )
  }

  showActivityMenu() {
    if (!this.state.activityMenuCollapsed) return

    this.setState(
      () => ({
        activityMenuCollapsed: false
      }),
      () => {
        document.addEventListener('click', this.hideMenus)
      }
    )
  }

  handleLoginClick(e) {
    e.preventDefault()

    showLogin()
  }

  handleSignUpClick(e) {
    e.preventDefault()

    showSignup()
  }

  handleLogoutClick = e => {
    e.preventDefault()

    window.localStorage.removeItem('auth0IdToken')

    location.reload()
  }

  handleBecomeAGuruClick(e) {
    e.preventDefault()

    if (this.props.user) {
      this.props.history.push('/create-guru-profile/details')
    } else {
      window.localStorage.setItem('authRedirect', '/create-guru-profile/details')
      this.handleSignUpClick(e)
    }
  }

  handleMyPlansClick(e) {
    e.preventDefault()

    if (this.props.user) {
      this.props.history.push('/my-plans')
    } else {
      window.localStorage.setItem('authRedirect', '/create-guru-profile/details')
      this.handleSignUpClick(e)
    }
  }


  handleMyTripsClick(e) {
    e.preventDefault()

    if (this.props.user) {
      this.props.history.push('/my-trips')
    } else {
      window.localStorage.setItem('authRedirect', '/create-guru-profile/details')
      this.handleSignUpClick(e)
    }
  }

  handleMyActivitiesClick(e) {
    e.preventDefault()

    if (this.props.user) {
      this.props.history.push('/activity-list')
    } else {
      window.localStorage.setItem('authRedirect', '/create-guru-profile/details')
      this.handleSignUpClick(e)
    }
  }

  handleBecomeAnActivityGuide(e) {
    e.preventDefault()

    if (this.props.user) {
      this.props.history.push('/activity-guide-profile/details')
    } else {
      window.localStorage.setItem('authRedirect', '/activity-guide-profile/details')
      this.handleSignUpClick(e)
    }
  }

  showUserMenu() {
    if (!this.state.userMenuCollapsed) {
      return false
    }

    this.setState(
      () => ({
        userMenuCollapsed: false
      }),
      () => {
        document.addEventListener('click', this.hideMenus)
      }
    )
  }

  hideMenus = () => {
    this.setState(
      () => ({
        navbarCollapsed: true,
        userMenuCollapsed: true,
        guideMenuCollapsed: true,
        activityMenuCollapsed: true
      }),
      () => {
        document.removeEventListener('click', this.hideMenus)
      }
    )
  }

  isGuideValid = () => {
    const { user } = this.props
    return user && user.guideProfile && user.guideProfile.approvalProcess == 'Approved'
  }

  isGuruValid = () => {
    const { user } = this.props
    return user && user.plannerProfile && user.plannerProfile.approvalProcess == 'Approved'
  }



  render() {

    if (this.props.loading) {
      return <Loader showLoader={true} />
    }

    const { user, t } = this.props

    const navbarClass = classNames({
      navbar: true,
      'navbar-collapse': true,
      collapsed: this.state.navbarCollapsed
    })

    const userMenuMobileClass = classNames({
      navbar: true,
      'navbar-collapse': true,
      collapsed: this.state.userMenuCollapsed
    })

    const guideMenuClass = classNames({
      'main-header__guide-menu': true,
      'main-header__dropdown-menu': true,
      hidden: this.state.guideMenuCollapsed
    })

    const activityMenuClass = classNames({
      'main-header__activity-menu': true,
      'main-header__dropdown-menu': true,
      hidden: this.state.activityMenuCollapsed
    })

    const guideMenuMobileClass = classNames({
      navbar: true,
      'navbar-collapse': true,
      collapsed: this.state.guideMenuCollapsed
    })

    const chevronClass = classNames({
      'main-header__chevron-down': this.state.navbarCollapsed,
      'main-header__chevron-up': !this.state.navbarCollapsed
    })

    return (
      <section className="container-fluid main-header__container">
        <div className="main-header__wrapper">
          <div
            className="main-header__logo-container"
            onClick={() => {
              this.showMainMenu()
            }}
          >
            <img src="/img/logo-new.png" className="main-header__logo__main" alt="Trippere logo" />
            <img src="/img/logo-mobile.png" className="main-header__logo__mobile" alt="Trippere logo" />
            <img src="/img/chevron-left.svg" className={chevronClass} alt="Menu down" />
          </div>
          <div className="main-header__navbar">
            <div className="col-md-4 ">
              <SelectInput
                      id="language"
                      initialValue={getDefaultLanguage()}
                      options={getLanguageOptions()}
                      simpleValue
                      clearable={false}
                      isGroup={false}
                      extendedClass='selectHeader'
                      onChangeExternal={(id, value) => { 
                        i18n.changeLanguage(value); 
                        window.location.reload()
                      }}
                    />
            </div>
            <button
              className="btn btn-sm btn-primary main-header__btn-1"
              onClick={() => {
                this.showActivityMenu()
              }}
            >
              {t('trip_activities')}
            </button>
            {user && (
              <div className="main-header__dropdown-menu-wrapper">
                <ul className={activityMenuClass}>
                  {!this.isGuruValid() && (
                  <li>
                    <a
                      href="#"
                      onClick={e => {
                        this.handleMyTripsClick(e)
                      }}
                    >
                      {t('my_trips')}
                    </a>
                  </li>
                  )}
                  {this.isGuruValid() && (
                  <li>
                    <a
                      href="#"
                      onClick={e => {
                        this.handleMyPlansClick(e)
                      }}
                    >
                      {t('my_plans')}
                    </a>
                  </li>
                  )}
                  {this.isGuideValid() && (
                  <li>
                    <a
                      href="#"
                      onClick={e => {
                        this.handleMyActivitiesClick(e)
                      }}
                    >
                      My activities
                    </a>
                  </li>
                  )}
                  </ul>
              </div>
            )}
            <button
              className="btn btn-sm btn-primary main-header__btn-2"
              onClick={() => {
                this.showGuideMenu()
              }}
            >
              {t('become_a_guide')}
            </button>
            <div className="main-header__dropdown-menu-wrapper">
              <ul className={guideMenuClass}>
                <li>
                  <a
                    href="#"
                    onClick={e => {
                      this.handleBecomeAGuruClick(e)
                    }}
                  >
                    {t('become_a_travel_guru')}
                  </a>
                </li>
                <li>
                  <a
                    to="#"
                    onClick={e => {
                      this.handleBecomeAnActivityGuide(e)
                    }}
                  >
                    {t('become_an_activity_guide')}
                  </a>
                </li>
              </ul>
            </div>
            {user ? (
              <MainMenuLoggedIn
                showUserMenu={() => {
                  this.showUserMenu()
                }}
                handleLogoutClick={e => {
                  this.handleLogoutClick(e)
                }}
                userMenuCollapsed={this.state.userMenuCollapsed}
                setChatOnTop={this.props.setChatOnTop}
                chatOnTop={this.props.chatOnTop}
                user={user}
              />
            ) : (
              <div className="flex">
                <div className="main-header__links">
                  <a href="#">{t('help')}</a>
                </div>
                <div className="main-header__auth">
                  <a
                    href="#"
                    onClick={e => {
                      this.handleLoginClick(e)
                    }}
                  >
                    {t('login')}
                  </a>
                  <a
                    href="#"
                    onClick={e => {
                      this.handleSignUpClick(e)
                    }}
                  >
                    {t('signup')}
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>
        <nav className={guideMenuMobileClass}>
          <ul className="nav navbar-nav">
            <li>
              <a
                href="#"
                onClick={e => {
                  this.handleBecomeAGuruClick(e)
                }}
              >
                {t('become_a_travel_guru')}
              </a>
            </li>
            <li>
              <a
                to="#"
                onClick={e => {
                  this.handleBecomeAnActivityGuide(e)
                }}
              >
                {t('become_an_activity_guide')}
              </a>
            </li>
          </ul>
        </nav>
        <nav className={userMenuMobileClass}>
          <ul className="nav navbar-nav">
            <li>
              <Link to="/profile">{t('my_profile')}</Link>
            </li>
            <li>
              <Link to="/trip-guru-orders">{t('my_orders')}</Link>
            </li>
            <li>
              <Link to="/review">{t('reviews')}</Link>
            </li>
            <li>
              <Link to="/settings">{t('settings')}</Link>
            </li>
            <li>
              <a href="#" onClick={this.handleLogoutClick}>
                {t('logout')}
              </a>
            </li>
          </ul>
        </nav>
        <nav className={navbarClass}>
          <ul className="nav navbar-nav">
            <li>
              <Link to="/">{t('home')}</Link>
            </li>
            <li>
              <a
                  href="#"
                  onClick={e => {
                    this.handleMyTripsClick(e)
                  }}
                >
                {t('trip_activities')}</a>
            </li>
            {user && (
              <li>
                <a href="#" onClick={this.props.setChatOnTop}>
                  {t('messages')}
                </a>
              </li>
            )}
            <li>
              <a href="#">{t('help')}</a>
            </li>
            {!user && (
              <li>
                <a
                  href="#"
                  onClick={e => {
                    this.handleLoginClick(e)
                  }}
                >
                  {t('login')}
                </a>
              </li>
            )}
            {!user && (
              <li>
                <a
                  href="#"
                  onClick={e => {
                    this.handleSignUpClick(e)
                  }}
                >
                  {t('signup')}
                </a>
              </li>
            )}
          </ul>
        </nav>
      </section>
    )
  }
}

const enhance = compose(
  translate('main'), 
  withRouter)
export default enhance(Navbar)



// WEBPACK FOOTER //
// src/components/Navbar/index.js